import React, { Component } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';

// ユーザー特定のための乱数生成
const l = 16;
const c = "abcdefghijklmnopqrstuvwxyz0123456789";
const cl = c.length;
let r = "";
for(let i=0; i<l; i++) {
  r += c[Math.floor(Math.random()*cl)];
}
const uuid = r

const price_text = {
  1: {
    30: "2,750円",
    60: "4,180円",
    90: "6,270円",
    120: "7,920円",
    150: "9,900円",
    180: "11,220円"
  },
  2: {
    30: "2,750円",
    60: "4,400円",
    90: "6,600円",
    120: "8,360円",
    150: "10,450円",
    180: "11,880円"
  },
  3: {
    30: "-",
    60: "-",
    90: "-",
    120: "8,800円",
    150: "11,000円",
    180: "12,650円"
  }
}

export default class Web extends Component {

  constructor (props) {
    super(props);

    this.state = {
      image: 0,
      next: 1,
      images: ["/images/homepage/top_image_1.jpg", "/images/homepage/top_image_2.jpg", "/images/homepage/top_image_3.jpg", "/images/homepage/top_image_4.jpg"],
      opacitys: [1, 0, 0, 0],
      use: 1,
      lot: 30
    };
  }

  componentDidMount () {
    if (this.props.match.params.section) {
      window.scrollTo(0, 100);
    }
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1', {gaOptions: {userId: uuid}});
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');
      
      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }

    var scope = this
    let i = 0;
    var opacitys = scope.state.opacitys
    const slide = () => {
      const slide_opacity = () => {
        i += 0.05
        opacitys[scope.state.image] = 1 - i
        opacitys[scope.state.next] = i
        scope.setState({opacitys: opacitys})
        const timeoutId = setTimeout(slide_opacity, 50)
        if (i > 1) {
          i = 0
          let next = scope.state.next
          next++
          if (scope.state.images.length <= next) {
            next = 0
          }
          let image = scope.state.image
          image++
          if (scope.state.images.length <= image) {
            image = 0
          }
          scope.setState({image: image, next: next})
          clearTimeout(timeoutId);
        }
      }
      slide_opacity()
      setTimeout(slide, 5000)
    }
    slide()
  }

  send() {
    window.location.href = "https://30min-7085787.hs-sites.com/%E4%BA%8B%E5%89%8D%E7%99%BB%E9%8C%B2-0-0";
  }

  inquiry() {
    window.location.href = "mailto:thirty-min@mec.co.jp";
  }

  covid() {
    window.location.href = "https://f.hubspotusercontent30.net/hubfs/7085787/%E6%96%B0%E5%9E%8B%E3%82%B3%E3%83%AD%E3%83%8A%E3%82%A6%E3%82%A3%E3%83%AB%E3%82%B9%E3%81%AB%E4%BF%82%E3%82%8B%E5%AF%BE%E5%BF%9C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6.pdf"
  }

  render () {
    const kv_images = this.state.images.map((image, i) => {
      return <img className="kv-images" src={image} alt="" style={{ opacity: this.state.opacitys[i] }} />
    });
    const kv_switchs = this.state.images.map((image, i) => {
      return <div className={[this.state.image === i ? "switch on" : "switch"]} />
    });
    return (
    <div className="web home">
      <div className="content-wrapper">
        <div className="homepage">

          <div className="header">
            <div className="logo">
              <img src="/images/homepage/logo.png" alt="" />
            </div>
            <nav className="mec-nav">
              <img src="/images/homepage/mitsubishi_jisyo.png" alt="" />
            </nav>
            <nav className="global-nav">
              <ul>
                <li><a href="#news">お知らせ</a></li>
                <li><a href="#service">サービス</a></li>
                <li><a href="#courses_and_fees">コース・料金</a></li>
                <li><a href="#faq">よくある質問</a></li>
                <li><a href="https://30min-7085787.hs-sites.com/%E4%BA%8B%E5%89%8D%E7%99%BB%E9%8C%B2-0-0">事前登録</a></li>
                <li><a href="mailto:thirty-min@mec.co.jp">お問い合わせ</a></li>
              </ul>
            </nav>
          </div>

          <div className="kv">
            {kv_images}
            <img className="image-tmp" src={this.state.images[0]} alt="" />
            <div className="switchs">
              {kv_switchs}
            </div>
            
            <div className="cv-button">
              <button onClick={this.send.bind(this)} className="background1">新規で事前登録される方はコチラ</button>
            </div>
          </div>

          <div className="cvs">
            <div className="cv-button">
              <button onClick={this.inquiry.bind(this)} className="background2">既にご利用いただいている方はコチラ</button>
            </div>
            <div className="price">
              <p className="text-3">メールフォームが開きますので、お問合せ内容につきご記入ください。<br />折り返し、事務局よりご連絡させていただきます。</p>
              <p className="text-4">※迷惑メール対策やドメイン指定受信等を設定している方は、確認メールが受信されますよう、【@mec.co.jp】の登録をお願いいたします。</p>
            </div>
          </div>

          <div className="content background-white" id="news">
            <img className="title-img" src="/images/homepage/heading_news.png" alt="" />
            <div className="news">
              <ul>
                <li>
                  <div className="date">2021.10.08</div>
                  <div className="tag">お知らせ</div>
                  <div className="title"><a href="/news/1">10/8　三菱地所の家事代行「30min.」ローンチいたしました！</a></div>
                </li>
              </ul>
            </div>
            <div className="sub-button">
              <button onClick={this.covid.bind(this)}>新型コロナウイルス感染症にかかる対応はこちら</button>
            </div>
          </div>

          <div className="explain">
            <div className="about">
              <img className="title-img" src="/images/homepage/heading_about_30min.png" alt="" />
              <div className="circles">
                <div className="circle background3">
                  <img src="/images/homepage/icon_round.svg" alt="" />
                  <p className="text-2">巡回型</p>
                  <p className="text-4">30min.のハウスキーパーがお住いのマンション内やエリアを巡回してサービスを行う、新しいかたちの家事代行サービスです。</p>
                </div>
                <div className="circle background4">
                  <img src="/images/homepage/icon_short_time.svg" alt="" />
                  <p className="text-2">短時間</p>
                  <p className="text-4">エリア内のサービスご利用日をまとめることで、これまでの家事代行サービスにはなかった、「短時間からのサービス提供」を実現しました。</p>
                </div>
                <div className="circle background5">
                  <img src="/images/homepage/icon_pinpoint.svg" alt="" />
                  <p className="text-2">ピンポイント</p>
                  <p className="text-4">短時間での利用が可能なことで、「お風呂だけ」と言った、負担となる家事だけをピンポイントで頼んでいただくことができるサービスです。</p>
                </div>
              </div>
              <div className="about-img">
                <img src="/images/homepage/about_illustration.png" alt="" />
              </div>
            </div>
            <div className="user-voice">
              <img className="title-img" src="/images/homepage/heading_voice.png" alt="" />
              <img className="sub-title-img" src="/images/homepage/subheading_voice.png" alt="" />
              <div className="voices">
                <div className="voice">
                  <div className="voice-title">毎週60分<br />水回りルーティン</div>
                  <img src="/images/homepage/customer_a.png" alt="" />
                  <div className="text-3 description">気になる水回りだけピンポイントでお願いしています<br />　</div>
                  <div className="text-4 description">毎週60分で、なかなか手の回らないキッチンとお風呂を交互にお願いしています。最近は、奇麗な状態がキープ出来る様になり、余った時間で、洗面所、お手洗い、玄関など、その時に気になっている箇所もお掃除いただています。</div>
                </div>
                <div className="voice">
                  <div className="voice-title">毎週120分<br />家の中をひと通り</div>
                  <img src="/images/homepage/customer_b.png" alt="" />
                  <div className="text-3 description">週に一度、家の中をリセットしてもらい、気持ちよく過ごせています</div>
                  <div className="text-4 description">自宅で仕事をしている時も、部屋が散らかっていると集中できなかったり憂鬱だったり…。特に水回りは週末にまとめてやろう、と思っていても出来ない事が多いので、定期的に部屋全体のお掃除をお願いする事にしました。</div>
                </div>
                <div className="voice">
                  <div className="voice-title">毎週60分<br />リビングダイニング</div>
                  <img src="/images/homepage/customer_c.png" alt="" />
                  <div className="text-3 description">30min.を使い始めて、子供と遊ぶ時間と、心の余裕が産まれました</div>
                  <div className="text-4 description">子供が産まれてから、リビングの汚れが気になり、60分だけお願いするようになりました。リビングダイニングに散らかったおもちゃの片付けと、埃取り、掃除機掛けの後に、なかなか手の回らない床の水拭きまでしてもらっています。</div>
                </div>
              </div>
            </div>
          </div>

          <div className="operators">
            <div className="housekeeper">
              <div className="illustration-wrapper">
                <img className="illustration" src="/images/homepage/housekeeper_illustration.png" alt="" />
              </div>
              <img className="title-img" src="/images/homepage/heading_housekeeper.png" alt="" />
              <div className="text-4">30min.のハウスキーパーは、三菱地所にて一人一人面接・研修を行い、<br />厳正な審査基準に合格したハウスキーパーのみ皆様のご自宅に<br />ご訪問させていただいています。30min.に所属する<br />ハウスキーパーからのメッセージを一部ご紹介させていただきます</div>
              <div className="desires">
                <div className="desire">
                  <div className="text-2">Nさんの想い</div>
                  <div className="desire-title">気になるポイントをしっかりと</div>
                  <img src="/images/homepage/housekeeper_a.png" alt="" />
                  <div className="text-3 description">お客様に「楽になった」と思っていただける事が、何よりも嬉しいです</div>
                  <div className="text-4 description">週に5日、家事代行のお仕事をしています。お客様に「楽になった」と思って頂く事が一番の喜びです。お掃除以外のお仕事も柔軟に対応致しますので、是非ご要望をお聞かせください！<br />　</div>
                </div>
                <div className="desire">
                  <div className="text-2">Sさんの想い</div>
                  <div className="desire-title">仕上がりを美しく</div>
                  <img src="/images/homepage/housekeeper_b.png" alt="" />
                  <div className="text-3 description">お客様に驚いていただける様な仕上がりを目指して<br />　</div>
                  <div className="text-4 description">100件以上の訪問経験があります。仕上がりの美しさにこだわって、お掃除しています。「丁寧なお掃除を、スピーディに」をモットーに、お客さまにご満足いただきたけるよう、日々精進して参りたいと思っています。</div>
                </div>
                <div className="desire">
                  <div className="text-2">Tさんの想い</div>
                  <div className="desire-title">きめ細かいサービスを</div>
                  <img src="/images/homepage/housekeeper_c.png" alt="" />
                  <div className="text-3 description">お客様のご要望や気持ちに寄り添ったサービスを心掛けています</div>
                  <div className="text-4 description">子育てが落ちついてから週３回のペースで家事代行のお仕事をしています。お客様に寄り添いながらきめ細かいサービスが出来るように心がけています。心地よい暮らし、そんなお手伝いが出来たら幸いです。</div>
                </div>
              </div>
            </div>
            <div className="company-desire">
              <img className="illustration" src="/images/homepage/for_all-pc.png" alt="" />
            </div>
          </div>

          <div className="services" id="service">
            <div className="service">
              <img className="illustration" src="/images/homepage/services_illustration.png" alt="" />
              <img className="title-img" src="/images/homepage/heading_services.png" alt="" />
              <img className="sub-title-img" src="/images/homepage/subheading_services.png" alt="" />
              <div className="text-4">まずは事前登録をいただきましたら、お住まいのエリアで<br />サービス提供が開始された時点で登録メールアドレスに<br />キャンペーン（お試しのご利用）お申込み案内を配信させていただきます。<br />一度お試しでご利用いただいた後に、定期でのお申し込みを承っております。</div>
              <div className="flows">
                <div className="flow">
                  <div className="step">
                    <img src="/images/homepage/step.svg" alt="" />
                    <img src="/images/homepage/step_1.svg" alt="" />
                  </div>
                  <div className="text">
                    <div className="text-2 description top-0padding">事前登録</div>
                    <div className="text-3 description top-0padding bottom-0padding">事前登録者が多く集まったエリア・マンションからサービスをスタートさせていただきます！まずは、是非ご登録ください！</div>
                  </div>
                  <div className="illust">
                    <img src="/images/homepage/step_1_illustration.png" alt="" />
                  </div>
                </div>
                <div className="cv-button top-0padding bottom-0padding">
                  <button onClick={this.send.bind(this)} className="background1">事前登録はコチラ</button>
                </div>
                <div className="flow">
                  <div className="step">
                    <img src="/images/homepage/step.svg" alt="" />
                    <img src="/images/homepage/step_2.svg" alt="" />
                  </div>
                  <div className="text">
                    <div className="text-2 description top-0padding">お知らせ配信</div>
                    <div className="text-3 description top-0padding bottom-0padding">サービスのスタートが決まりましたら、事前登録のお客様宛に「サービススタートのお知らせ」を配信させていただきます</div>
                  </div>
                  <div className="illust">
                    <img src="/images/homepage/step_2_illustration.png" alt="" />
                  </div>
                </div>
                <div className="flow">
                  <div className="step">
                    <img src="/images/homepage/step.svg" alt="" />
                    <img src="/images/homepage/step_3.svg" alt="" />
                  </div>
                  <div className="text">
                    <div className="text-2 description top-0padding">キャンペーンのお申し込み</div>
                    <div className="text-3 description top-0padding bottom-0padding">サービス対象エリアにお住いの皆様は、お得なお試しキャンペーンをご利用いただけます！ぜひ、お申込みください！</div>
                  </div>
                  <div className="illust">
                    <img src="/images/homepage/step_3_illustration.png" alt="" />
                  </div>
                </div>
                <div className="flow">
                  <div className="step">
                    <img src="/images/homepage/step.svg" alt="" />
                    <img src="/images/homepage/step_4.svg" alt="" />
                  </div>
                  <div className="text">
                    <div className="text-2 description top-0padding">定期でのご利用</div>
                    <div className="text-3 description top-0padding bottom-0padding">「30min.」のサービスは定期訪問のみのサービスとなっています。お試しキャンペーン後、ご継続をご希望される場合には、定期ご利用のお申し込みをいただきます</div>
                  </div>
                  <div className="illust">
                    <img src="/images/homepage/step_4_illustration.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="courses-and-fees" id="courses_and_fees">
            <div className="course-wrapper">
              <img className="illustration" src="/images/homepage/courses_and_fees_illustration.png" alt="" />
              <img className="title-img" src="/images/homepage/heading_courses_and_fees.png" alt="" />
              <img className="sub-title-img" src="/images/homepage/subheading_courses_and_fees.png" alt="" />
              <div className="text-4">「30min.」のサービスは定期訪問のみのサービスとなっています。<br />対象のお掃除箇所については、お選びの時間により変わります。<br />又、料金については、ご利用頻度によって異なります。</div>

              <div className="inner-space">
                <div className="icon">
                  <img src="/images/homepage/icon_time.svg" alt="" />
                </div>
                <div className="text-1 top-0padding bottom-0padding">お掃除コース</div>
                <div className="text-3 top-0padding bottom-0padding">各コースからお選びいただけます</div>
              </div>

              <div className="courses">
                <div className="course">
                  <div className="text-1">
                    <img src="/images/homepage/course_check.svg" alt="" />
                    30分コース
                  </div>
                  <div className="text-3"><div><span className="accent">どちらか1箇所</span>を選択できます。</div></div>
                  <div className="inner-frame">リビング・ダイニング（30分）</div>
                  <div className="inner-frame">洗面所・お手洗い（30分）</div>
                </div>
                <div className="course">
                  <div className="text-1">
                    <img src="/images/homepage/course_check.svg" alt="" />
                    60〜180分コース
                  </div>
                  <div className="text-3"><div>4箇所から、お掃除時間に応じ、<span className="accent">複数箇所</span>を選択できます。</div></div>
                  <div className="inner-frame">リビング・ダイニング（30分）</div>
                  <div className="inner-frame">洗面所・お手洗い（30分）</div>
                  <div className="inner-frame">お風呂（45～60分）</div>
                  <div className="inner-frame">キッチン（45～60分）</div>
                </div>
              </div>

              <div className="notes">
                <p className="text-4 description top-0padding bottom-0padding">※30分単位でお選びいただけます ※180分以上のご依頼もお受けしております ※カッコ内は目安の時間になります</p>
                <p className="text-4 description top-0padding bottom-0padding">※60～180分コースでのお掃除箇所数につきましては、お部屋の広さや普段のお掃除頻度等によって異なります。</p>
                <p className="text-4 description top-0padding bottom-0padding">※本サービスは時間での契約・サービスのご提供となります。</p>
              </div>

              <div className="inner-space">
                <div className="icon">
                  <img src="/images/homepage/icon_money.svg" alt="" />
                </div>
                <div className="text-1 top-0padding bottom-0padding">料金プラン</div>
                <div className="text-3 top-0padding bottom-0padding">時間が長くなればなるほど、お得になる料金プラン</div>
              </div>

              <div className="fees">
                <table>
                  <thead>
                    <tr>
                      <th>&nbsp;</th>
                      <th>週1回以上</th>
                      <th>月2回</th>
                      <th>月1回</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>30分／回</th>
                      <td>2,750円</td>
                      <td>2,750円</td>
                      <td>ー</td>
                    </tr>
                    <tr>
                      <th>60分／回</th>
                      <td>4,180円</td>
                      <td>4,400円</td>
                      <td>ー</td>
                    </tr>
                    <tr>
                      <th>90分／回</th>
                      <td>6,270円</td>
                      <td>6,600円</td>
                      <td>ー</td>
                    </tr>
                    <tr>
                      <th>120分／回</th>
                      <td>7,920円</td>
                      <td>8,360円</td>
                      <td>8,800円</td>
                    </tr>
                    <tr>
                      <th>150分／回</th>
                      <td>9,900円</td>
                      <td>10,450円</td>
                      <td>11,000円</td>
                    </tr>
                    <tr>
                      <th>180分／回</th>
                      <td>11,220円</td>
                      <td>11,880円</td>
                      <td>12,650円</td>
                    </tr>
                    <tr>
                      <th>180分以上、30分あたり</th>
                      <td><span className="accent">+1,870円</span></td>
                      <td><span className="accent">+1,980円</span></td>
                      <td><span className="accent">+2,090円</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="notes">
                <p className="text-4 description top-0padding bottom-0padding">※回数は週複数回～月1回まで選べます ※<span className="accent">月1回の場合には120分以上</span>でのお申込みのみ承っております</p>
                <p className="text-4 description top-0padding bottom-0padding">※月2回の場合は隔週のみ（第1・3週又は第2・4週）となります ※上記は税込み・交通費込みの価格になります。</p>
              </div>

              <div className="simulations">
                <div className="inner-space">
                  <div>
                    <p className="text-2 description left-0padding"><span className="title-accent">料金シミュレーション</span></p>
                    <p className="text-3 description left-0padding">ご希望の内容を選択して、ご利用料金を確認いただけます</p>
                    <div className="simulation">
                      <div className="choices">
                        <p className="text-3 bottom-0padding">頻度選択</p>
                        <select onChange={e => this.setState({use: e.target.value})}>
                          <option value="1">週1回以上</option>
                          <option value="2">月2回</option>
                          <option value="3">月1回</option>
                        </select>
                      </div>
                      <div className="calc">×</div>
                      <div className="choices">
                        <p className="text-3 bottom-0padding">時間選択</p>
                        <select onChange={e => this.setState({lot: e.target.value})}>
                          <option value="30">30分</option>
                          <option value="60">60分</option>
                          <option value="90">90分</option>
                          <option value="120">120分</option>
                          <option value="150">150分</option>
                          <option value="180">180分</option>
                        </select>
                      </div>
                      <div className="calc">=</div>
                      <div className="choices">
                        <p className="text-3 bottom-0padding">1回あたりの金額</p>
                        <p className="sum">{price_text[this.state.use][this.state.lot]}</p>
                      </div>
                    </div>
                    <p className="text-4 description left-0padding">※上記は、交通費込・税金込の金額となります。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="area-and-mansions" id="area-and-mansions">
            <div className="area-wrapper">
              <img className="illustration" src="/images/homepage/area_illustration.png" alt="" />
              <img className="title-img" src="/images/homepage/heading_area.png" alt="" />
              <img className="sub-title-img" src="/images/homepage/subheading_area.png" alt="" />
              <div className="text-4">サービス提供エリアは順次拡大中です。<br />事前登録者が多く集まったエリア・マンションから<br />サービスをスタートさせていただきますので<br />まずは「事前登録」フォームよりご登録ください！</div>

              <div className="areas">
                <div className="area">
                  <div className="inner-frame">港区(一部)</div>
                  <div className="inner-frame">文京区</div>
                  <div className="inner-frame">千代田区</div>
                  <div className="inner-frame">中央区</div>
                </div>
              </div>

              <div className="mansions">
                <div className="text-2 description">サービス展開中のマンション</div>
                <ul>
                  <li>ザ・パークハウス市ヶ谷</li>
                  <li>キャピタルゲートプレイス ザ・タワー</li>
                  <li>ザ・パークハウス三田タワー</li>
                  <li>ザ・パークハウス晴海タワーズ ティアロレジデンス</li>
                  <li>パークコート一番町</li>
                  <li>クラッシィハウス芝浦</li>
                  <li>ザ・パークハウス晴海タワーズクロノレジデンス</li>
                  <li>ザ・パークハウス麻布外苑西通り</li>
                  <li>ファミール芝公園グランスイート</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="content background-white" id="faq">
            <div className="text-2">よくある質問</div>
            <ul className="qa">
              <li>
                <div className="text-1 bottom-0padding">Q1.</div>
                <div className="text-3 bottom-0padding description">家事代行って、どこまでやってくれるの？</div>
                <div className="text-4 description">30minの家事代行サービスは、研修を受けたハウスキーパーがお客様宅にお伺いし、お客様がお持ちの道具・洗剤をお借りして、日常のお掃除（バスルームやキッチンなどの水回りなど）を実施します。</div>
              </li>
              <li>
                <div className="text-1 bottom-0padding">Q2.</div>
                <div className="text-3 bottom-0padding description">ハウスクリーニングとの違いは？</div>
                <div className="text-4 description">プロが利用する洗剤・機材を持ち込み、専門の技術を持ったプロが清掃するハウスクリーニングとは異なり、 家事代行サービスは、お客様がお持ちの道具・洗剤をお借りし、お客様の代わりにハウスキーパーが日常的な家事を行うサービスとなります。</div>
              </li>
              <li>
                <div className="text-1 bottom-0padding">Q3.</div>
                <div className="text-3 bottom-0padding description">スポットで利用することはできますか？</div>
                <div className="text-4 description">現状、30min.は定期契約のみのサービスとなっております。 まずは、キャンペーンにてお試しいただき、その後、定期契約へ移行いただいた場合にのみサービスのご利用が可能となっています。</div>
              </li>
              <li>
                <div className="text-1 bottom-0padding">Q4.</div>
                <div className="text-3 bottom-0padding description">ハウスキーパーはどのような人が来ますか？</div>
                <div className="text-4 description">お客様に安心してサービスをご利用いただけるように、30minでは採用と育成の仕組みを作っております。採用時に経歴の確認及び当社の選考基準に基づく面接、研修に合格したスタッフのみが正式なハウスキーパーとして、お客様のご自宅にお伺いすることができます。</div>
              </li>
              <li>
                <div className="text-1 bottom-0padding">Q5.</div>
                <div className="text-3 bottom-0padding description">不在時でもサービス利用できますか？</div>
                <div className="text-4 description">初回サービス時は、基本的にご在宅をお願いしております。 定期契約のお客様で、2回目以降について、ご不在時のサービスを希望される方は「鍵のお預かり」プランをご用意しています。詳しくは30min.事務局本部までお問い合わせください。</div>
              </li>
            </ul>
          </div>

          <div className="footer">
            <ul>
              <li><a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E7%89%B9%E5%AE%9A%E5%95%86%E5%8F%96%E5%BC%95%E3%81%AB%E4%BF%82%E3%82%8B%E6%A8%99%E8%A8%98.pdf">特定商取引に基づく表記</a></li>
              <li><a href="https://www.mec.co.jp/j/privacy/">プライバシーポリシー</a></li>
              <li><a href="https://www.mec.co.jp/">運営会社</a></li>
            </ul>
            <div className="cv-button">
              <button onClick={this.inquiry.bind(this)} className="background6">お問い合わせはコチラ</button>
            </div>
            <img src="/images/homepage/logo.png" alt="" />
            <div className="text-4">Copyright © MITSUBISHI ESTATE Co., Ltd. All Rights Reserved.</div>
          </div>

          <div className="content">
            <img className="phrase_logo" src="/images/homepage/mitsubishi_jisyo_phrase.png" alt="" />
            <div className="cv-button">
              <button onClick={this.send.bind(this)} className="background7">事前登録はコチラ</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    );
  }
}